import { Controller } from "@hotwired/stimulus"

// connects to data-controller="soft-tissue-diagram"
export default class extends Controller {
  static targets = ["observationTextarea"]

  connect() {
    this.currentTissue = "ls";
    this.selectTissue("LS");
    setTimeout(() => {
      this.loadInitialContent();
    }, 100);
  }

  selectTissue(event) {
    this.saveCurrentObservation();

    let tissue;
    if (typeof event === 'object' && event.currentTarget) {
      const button = event.currentTarget;
      tissue = button.dataset.tissue;

      const buttons = document.querySelectorAll('.tissue-btn');
      buttons.forEach(b => b.classList.remove('active', 'bg-blue-200', 'border-2', 'border-blue-500'));
      button.classList.add('active', 'bg-blue-200', 'border-2', 'border-blue-500');
    } else {
      tissue = event;
    }

    const tissueKey = typeof tissue === 'string' ? tissue.toLowerCase() : String(tissue).toLowerCase();
    this.currentTissue = tissueKey;

    const titleMap = {
      'ls': 'Labio Superior',
      'pd': 'Paladar Duro',
      'pb': 'Paladar Blando',
      'of': 'Orofaringe',
      'myd': 'Mucosa Yugal Derecha',
      'myi': 'Mucosa Yugal Izquierda',
      'l': 'Lengua',
      'sl': 'Sublingual',
      'li': 'Labio Inferior',
      'cd': 'Comisura Derecha',
      'ci': 'Comisura Izquierda'
    };

    document.getElementById('selected-tissue-title').textContent = titleMap[tissueKey];

    const hiddenField = document.getElementById(`soft_tissue_${tissueKey}_observation`);
    if (hiddenField) {
      this.observationTextareaTarget.value = hiddenField.value || '';
    }
  }

  updateObservation() {
    this.saveCurrentObservation();
  }

  saveCurrentObservation() {
    if (!this.currentTissue) return;

    const hiddenField = document.getElementById(`soft_tissue_${this.currentTissue}_observation`);
    if (hiddenField) {
      hiddenField.value = this.observationTextareaTarget.value;
    }
  }

  loadInitialContent() {
    const lsField = document.getElementById('soft_tissue_ls_observation');
    
    if (lsField && this.observationTextareaTarget) {
      const content = lsField.value || '';
      
      if (content.trim() !== '' && this.observationTextareaTarget.value.trim() === '') {
        this.observationTextareaTarget.value = content;
      }
    }
  }
}
